import { Container, Typography, Box, List, ListItem, ListItemText } from "@mui/material";
import { Helmet } from "react-helmet";

export default function ComparisonsAiFr() {
  const base =
    (typeof window !== "undefined" && window.location && window.location.origin) ||
    "https://talk-mate-backend.web.app";
  const enUrl = `${base}/en/compare-chatbot`;
  const frUrl = `${base}/fr/comparatif-chatbot-ia`;

  return (
    <Container sx={{ py: 6 }}>
      <Helmet>
        <title>Talkmate – alternative chatbot IA pour sites web</title>
        <meta
          name="description"
          content="Créez un chatbot IA, configurez le contexte, déployez-le par embed ou lien, et basculez en réponse manuelle."
        />
        <meta property="og:title" content="Talkmate – alternative chatbot IA" />
        <meta
          property="og:description"
          content="Talkmate permet d’ajouter un widget ou une iframe, partager un lien public, et faire un handoff opérateur."
        />
        <meta name="robots" content="index, follow" />
        <link rel="alternate" href={enUrl} hrefLang="en" />
        <link rel="alternate" href={frUrl} hrefLang="fr" />
        <link rel="canonical" href={frUrl} />
      </Helmet>

      <Typography variant="h3" fontWeight={800} gutterBottom>
        Talkmate : alternative chatbot IA pour sites web
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Talkmate permet de créer un agent IA, d’ajouter un widget ou une iframe, de partager un lien public et de gérer
        le handoff manuel (réponse opérateur) sans coder.
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Points clés
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="Widget, lien public, iframe pour répondre automatiquement aux visiteurs." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Mode manuel : stoppez l’IA et répondez vous-même quand c’est nécessaire." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Multilingue, contextuel, configurable en quelques minutes." />
          </ListItem>
        </List>
      </Box>

      <Box>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Cas d’usage
        </Typography>
        <List dense>
          <ListItem>
            <ListItemText primary="FAQ et support client sur site web, capture de leads." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Assistants produit pour SaaS, agences, e-commerce." />
          </ListItem>
          <ListItem>
            <ListItemText primary="Réponses 24/7, avec possibilité d’intervention humaine." />
          </ListItem>
        </List>
      </Box>
    </Container>
  );
}
